import UcProductInvoiceGroupLabel from './UcProductInvoiceGroupLabel.yaml?component';
import UcProductMiniCard from './UcProductMiniCard.yaml?component';
import UcSuggestProductOption from './UcSuggestProductOption.yaml?component';

export { UcProductInvoiceGroupLabel, UcProductMiniCard, UcSuggestProductOption };
